import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/modules/shared/ui/components/alert-dialog"
import { useDeleteFolder } from "../../hooks/useFolders"

interface DeleteFolderDialogProps {
  folderId: string
  folderName: string
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleted?: () => void
}

export function DeleteFolderDialog({
  folderId,
  folderName,
  open,
  onOpenChange,
  onDeleted,
}: DeleteFolderDialogProps) {
  const deleteFolder = useDeleteFolder()

  const handleConfirm = () => {
    deleteFolder.mutate(folderId, {
      onSuccess: () => {
        onOpenChange(false)
        onDeleted?.()
      },
    })
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete &quot;{folderName}&quot;?</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently delete the folder. The folder must be empty
            before it can be deleted.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={deleteFolder.isPending}
            onClick={handleConfirm}
          >
            {deleteFolder.isPending ? "Deleting…" : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
